import { htmlToPlainText } from "./tokens";

// Try the async Clipboard API with ClipboardItem carrying text/html + text/plain.
// Fall back to a hidden contenteditable + document.execCommand('copy').
export async function copyRichHtml(html) {
    const plain = htmlToPlainText(html);
    try {
        if (window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
            const item = new window.ClipboardItem({
                "text/html": new Blob([html], { type: "text/html" }),
                "text/plain": new Blob([plain], { type: "text/plain" }),
            });
            await navigator.clipboard.write([item]);
            return true;
        }
    } catch (err) {
        console.warn("Clipboard API failed, using fallback", err);
    }
    // Fallback path
    return copyRichHtmlLegacy(html);
}

function copyRichHtmlLegacy(html) {
    const container = document.createElement("div");
    container.setAttribute("contenteditable", "true");
    container.style.position = "fixed";
    container.style.left = "-10000px";
    container.style.top = "0";
    container.style.opacity = "0";
    container.innerHTML = html;
    document.body.appendChild(container);

    const range = document.createRange();
    range.selectNodeContents(container);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    let ok = false;
    try {
        ok = document.execCommand("copy");
    } catch (e) {
        ok = false;
    }
    sel.removeAllRanges();
    document.body.removeChild(container);
    return ok;
}

export async function copyPlainText(text) {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (err) {
        console.warn("Clipboard writeText failed", err);
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-10000px";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
        ok = document.execCommand("copy");
    } catch (e) {
        ok = false;
    }
    document.body.removeChild(ta);
    return ok;
}
